<template>
  <v-sheet style="min-height: 100%">
    <v-container>
      <div>
        <v-card class="mx-auto">
          <v-card-title dark tabs flat>
            Caixa de Entrada
          </v-card-title>
          <v-tabs v-model="tabs" color="#4B2A66">
            <v-tab>
              Recebidas
              <v-icon> mdi-email </v-icon>
            </v-tab>
            <v-tab>
              Visualizadas
              <v-icon> mdi-check </v-icon>
            </v-tab>
            <v-tab-item>
              <v-card>
                <v-list two-line>
                  <v-list-item-group active-class="#4B2A66" multiple>
                    <template v-for="(message, index) in messages">
                      <v-list-item
                        :key="message.id"
                        @click.stop="
                          (name = name_user[index]),
                            (email = emails_user[index]),
                            (text = message.message),
                            viewedMessage(message.id),
                            (dialog = true)
                        "
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ name_user[index] }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ message.message }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card>
                <v-list two-line>
                  <v-list-item-group active-class="pink--text" multiple>
                    <template v-for="(viewed, index) in messages_viewed">
                      <v-list-item
                        :key="viewed.title"
                        @click.stop="
                          (name = name_user_viewed[index]),
                            (email = emails_user_viewed[index]),
                            (text = viewed.message),
                            (dialog = true)
                        "
                      >
                        <template>
                          <v-list-item-content>
                            <v-list-item-title>
                              {{ name_user_viewed[index] }}
                            </v-list-item-title>
                            <v-list-item-subtitle>
                              {{ viewed.message }}
                            </v-list-item-subtitle>
                          </v-list-item-content>

                          <v-list-item-action>
                            <v-icon color="pink"> mdi-check </v-icon>
                          </v-list-item-action>
                        </template>
                      </v-list-item>
                    </template>
                  </v-list-item-group>
                </v-list>
              </v-card>
            </v-tab-item>
            <v-tabs-slider color="white" />
          </v-tabs>
        </v-card>
      </div>
    </v-container>
    <v-dialog v-model="dialog" width="500px" height="auto">
      <v-card color="pink darken-2">
        <v-container>
          <v-row>
            <v-col>
              <div class="text-h5 white--text">{{ name }}</div>
              <div class="white--text d-flex justify-start">{{ email }}</div>
            </v-col>
            <v-col class="d-flex justify-end">
              <v-btn color="red lighten-2" icon @click="dialog = false">
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <div class="white--text" style="height: 100px">{{ text }}</div>
        </v-container>
      </v-card>
    </v-dialog>
  </v-sheet>
</template>

<script>
export default {
  data: () => ({
    row: null,
    drawer: true,
    pagemenu: false,
    tabs: null,
    dialog: false,
    name: "",
    email: "",
    shop: {},
    text: "",
    name_user: [],
    name_user_viewed: [],
    emails_user: [],
    emails_user_viewed: [],
    id_shop: "",
    messages: [],
    messages_viewed: [],
  }),
  mounted() {
    this.$axios.get("/shop/" + this.$route.params.shop_url).then((response) => {
      this.shop = response.data;
      document.title = `Olhadela - ${this.shop.shop_name}`;
      this.id_shop = response.data.id;
      this.$axios.get("/shop/message/" + this.id_shop).then((response) => {
        this.messages = response.data[0];
        var n = 0;
        for (n in this.messages)
          this.$axios
            .get("/user/" + this.messages[n].user_id)
            .then((response) => {
              this.name_user.push(response.data[0].name);
              this.emails_user.push(response.data[0].email);
            });
      });
      this.$axios.get("/shop/messages/" + this.id_shop).then((response) => {
        this.messages_viewed = response.data;
        var n = 0;
        for (n in this.messages_viewed)
          this.$axios
            .get("/user/" + this.messages_viewed[n].user_id)
            .then((response) => {
              this.name_user_viewed.push(response.data[0].name);
              this.emails_user_viewed.push(response.data[0].email);
            });
      });
    });
  },
  methods: {
    viewedMessage(message_id) {
      this.$axios.put("/shop/message/" + message_id);
    },
  },
  watch: {
    dialog() {
      this.$axios.get("/shop/message/" + this.id_shop).then((response) => {
        this.messages = response.data[0];
        var n = 0;
        for (n in this.messages)
          this.$axios
            .get("/user/" + this.messages[n].user_id)
            .then((response) => {
              this.name_user.push(response.data[0].name);
              this.emails_user.push(response.data[0].email);
            });
      });
      this.$axios.get("/shop/messages/" + this.id_shop).then((response) => {
        this.messages_viewed = response.data;
        var n = 0;
        for (n in this.messages_viewed)
          this.$axios
            .get("/user/" + this.messages_viewed[n].user_id)
            .then((response) => {
              this.name_user_viewed.push(response.data[0].name);
              this.emails_user_viewed.push(response.data[0].email);
            });
      });
    },
  },
};
</script>
